import { Component, Input } from '@angular/core';
import { CardComponent } from '../card/card.component';

@Component({
  selector: 'info-card',
  templateUrl: './info-card.component.html',
  standalone: false
})
export class InfoCardComponent extends CardComponent {
  @Input() icon: string;
  @Input() title: string;
}
